<!--
 Filter Container Mobile
 Show facets and handle filter communication for mobile devices.
 devs@droxit.de
 Copyright (c) 2021 droxIT GmbH
-->

<template>
  <b-container fluid="md" id="rocketsearch-facets-container">
    <div v-for="facet in facets" :key="facet.name" style="width:100%;">
      <TermsFacetMobile
        v-if="facet.type=='terms'"
        :facet=facet
        :filter=filters[facet.name]
        :key=getKey(facet)
      />
      <RangeSliderMobile
        v-if="facet.type=='range'"
        :facet=facet
        :filter=filters[facet.name]
        :key=getKey(facet)
      />
      <hr class="rocketsearch-column-header-underline">
    </div>
  </b-container>
</template>

<script>
  import TermsFacetMobile from "./Facets/TermsFacetMobile.vue";
  import RangeSliderMobile from "./Facets/RangeSliderMobile.vue";

  /*
  * The Result Container, showing preview or all results for a search term
  */
  export default {
    name: 'FacetsContainerMobile',
    props: {
      facets: Array,
      filters: Object
    },
    components: {
      TermsFacetMobile,
      RangeSliderMobile,
    },
    methods: {
      getKey(facet){
          if(facet.type=="terms"){
            return facet.options.map(x => x.value + ":" + x.num).reduce((acc, curr) => acc + curr, "");
          }
          if(facet.type=="range"){
            return facet.from + "-" + facet.to;
          }
        return 0;
      }
    }
  }
</script>